import React, { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import "./Faqs.css"

const Faqs = () => {
    window.scroll(0,0);
    const {t} = useContext(LanguageContext)
    const faqsList = t("faqs", "questions");

    return (
    <div id="faqs-section">
        <h1>{t("faqs", "title")} </h1>
        <div className="faqs-section-list">
            {faqsList.map((faq, key)=> (
                <label key={key} className="faqs-section-item">
                    <input type="checkbox"/>
                    <div className="faq-section-item-title">
                        <span class="material-symbols-outlined"> {faq.icon} </span>
                        <h3> {faq.question}</h3>
                    </div>
                    <p>{faq.answer}</p>
                    
                </label>
            ))}
        </div>
    </div>
    );
}
export default Faqs;